<template>
	<span>
		<base-button
			ghost
			inline
			icon-before="tick"
			@click="$emit('save-layout')"
			success-invert
			v-if="isEdit"
			>Save Layout</base-button
		>
		<base-button
			ghost
			inline
			:icon-before="isEdit ? 'cross' : 'cog'"
			@click="$emit('toggle-customize')"
			:danger-invert="isEdit"
			>{{ !isEdit ? 'Customise layout' : 'Cancel' }}</base-button
		>
	</span>
</template>

<script>
export default {
	props: {
		editMode: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			isEdit: false,
		}
	},

	watch: {
		editMode: {
			immediate: true,
			deep: true,
			handler(newValue, oldValue) {
				this.isEdit = newValue
			},
		},
	},
}
</script>

<style lang="scss" scoped></style>
